import { Navegation } from "components/Navegation"
import * as S from './styles'
import { useEffect, useState } from "react"
import fetchAxios from "services/http"
import { useUserProvider } from "hooks/userContext"
import { Inputs } from "components/Input"
import { RegisterCreditCard } from "pages/Payment/components/RegisterCreditCard"
import { PaymentTypeState } from "pages/Payment"
import { Loading } from "pages/Payment/components/Loading"
import { usePaymentProvider } from "context/paymentContext"
import { useNavigate } from "react-router-dom"
import useIsMobile from "pages/Mobile/useMobile"
import { BlockedUserAlert } from "pages/Payment/components/BlockedUserAlert"
import { ProductCard } from "components/ProductCard"
import { Button } from "components/Button"
import { ModalReturnValidation } from "components/Input/Radio"
import { useScreenWidth } from "utils/useScreenWidth"
import { ALLOWED_PAYMENT_TYPES } from "pages/Payment/constants/allowedPaymentTypes"

export const PaymentInfo = () => {

    const { cardPaymentBlock } = useUserProvider()
    const breakpoint = useScreenWidth()
    const navigate = useNavigate()

    const isCreditCardAllowed = (ALLOWED_PAYMENT_TYPES as readonly string[]).includes('CREDIT_CARD')

    if (cardPaymentBlock === 'true' || !isCreditCardAllowed) {
        navigate('/', { replace: true })
    }

    document.title = "Informações de pagamento | Yogha";

    const [cards, setCards] = useState<any[]>([])
    const [paymentType, setPaymentType] = useState<PaymentTypeState>({ cardId: '', type: '' })
    const [openRegisterCard, setOpenRegisterCard] = useState<boolean>(false)
    const [reload, setReload] = useState<boolean>(false)
    const [loadingMessage, setLoadingMessage] = useState<string>('')
    const [isBlocked, setIsBlocked] = useState<boolean>(false)
    const [openLogoutModal, setOpenLogoutModal] = useState<boolean>(false)
    const [openModalValidation, setOpenModalValidation] = useState<boolean>(false)
    const [idCardValidate, setIdCardValidate] = useState<string>('')

    const isMobile = useIsMobile()

    const { token, statusAccount } = useUserProvider()

    const { isLoading } = usePaymentProvider()

    useEffect(() => {
        const getCreditCards = async () => {
            try {
                const res = await fetchAxios.get('payment/cards', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                })
                setCards(res.data)
            } catch (error) {
            }

        }
        getCreditCards()
    }, [reload, openRegisterCard])

    const handleReload = () => {
        setTimeout(() => {
            setReload(!reload)
        }, 3000);
    }

    const handleRegisterCard = () => {
        if (statusAccount === "Bloqueado") {
            setIsBlocked(true)
        } else if (isMobile) {
            navigate('/register-card')
        } else {
            setOpenRegisterCard(true)
        }
    }

    const plusIcon = require('assets/svg/payment/Plus.svg').default

    return (
        <>
            <S.Container>
                <Navegation actualPage="Informações de pagamento" />
                <S.Title>Informações de pagamento</S.Title>
                <S.CardContainer>
                    <S.Column>
                        <strong>Cartão de crédito</strong>
                        {cards?.length > 0 ? null : <h4>Você não possui cartões cadastrados</h4>}
                        <S.ContainerInput>
                            {cards?.map((card) => (
                                <S.InputPayment key={card.id} onClick={() => setPaymentType(card.id)}>
                                    <Inputs.Radio loadingMessage={setLoadingMessage} setReload={setReload} onClick={handleReload} verify={card.validated} lastNumber={card.last_numbers} cardId={card.id} token={card.token} brand={card.brand} type='CREDIT_CARD' paymentType={paymentType} setPaymentType={setPaymentType} isBlock={card.is_blocked} setOpenModalValidation={setOpenModalValidation} setIdCardValidate={setIdCardValidate} />
                                </S.InputPayment>
                            ))}

                            {cards && cards.length < 5 ? <S.InputPayment onClick={handleRegisterCard}>
                                <img src={plusIcon} alt="" />
                                <p>Adicionar cartão de crédito</p>
                            </S.InputPayment>
                                : null}

                        </S.ContainerInput>
                    </S.Column>
                </S.CardContainer>
            </S.Container>
            {openRegisterCard && <RegisterCreditCard setOpenLogoutModal={setOpenLogoutModal} setReload={setReload} open={openRegisterCard} setOpen={setOpenRegisterCard} />}
            {isLoading ? <Loading text={loadingMessage} /> : null}
            <ProductCard key={'logout-blocked-user'} bottomLine width={breakpoint ? 'calc(100% - 48px )' : '290'} title='Atividade incomum' isOpen={openLogoutModal} setIsOpen={setOpenLogoutModal}>
                <S.TextHeading>Detectamos atividade incomum durante a validação dos seus cartões de crédito. Para sua segurança, os pagamentos com cartão de crédito estão temporariamente indisponíveis. Entre em contato com nosso suporte para resolver esta situação.</S.TextHeading>
                <Button size='medium' title='Entendido' type='primary' onClickButton={() => navigate('/login')} />
            </ProductCard>
            <ModalReturnValidation setReload={setReload} idCardValidate={idCardValidate} key={token + 'validation'} open={openModalValidation} setOpen={setOpenModalValidation} setOpenLogoutModal={setOpenLogoutModal} token={token} />
            <BlockedUserAlert blockedUser={isBlocked} setIsBlockedUser={setIsBlocked} />
        </>
    )
}